/**
 * 功能权限接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FunctionalJurisdictionService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 功能权限接口
  /**
   * 保存或删除功能权限
   * @param param
   */
  saveOrDeleteByParam(param) {
    const url = this.prefix + 'roleFunction/saveOrDeleteByParam';
    return this.http.Post(url, param);
  }

  /**
   * 查看用户的隐藏角色id
   * @param param
   */
  checkUserId(param) {
    const url = this.prefix + 'role/queryById';
    return this.http.Post(url, param);
  }

  //#endregion


}
